// Cuenta regresiva y acceso con contraseña de la página de preventa.
// Ver sections/preventa-countdown.liquid

class PreventaCuenta extends HTMLElement {
  connectedCallback() {
    this.lanzamiento = Date.parse(this.dataset.lanzamiento);
    if (Number.isNaN(this.lanzamiento)) return;

    this.campos = {
      dias: this.querySelector('[data-dias]'),
      horas: this.querySelector('[data-horas]'),
      minutos: this.querySelector('[data-minutos]'),
      segundos: this.querySelector('[data-segundos]'),
    };
    this.actualizar();
    this.intervalo = setInterval(() => this.actualizar(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.intervalo);
  }

  actualizar() {
    const restante = Math.max(0, this.lanzamiento - Date.now());
    const s = Math.floor(restante / 1000);
    const dos = (n) => String(n).padStart(2, '0');

    this.campos.dias.textContent = dos(Math.floor(s / 86400));
    this.campos.horas.textContent = dos(Math.floor(s / 3600) % 24);
    this.campos.minutos.textContent = dos(Math.floor(s / 60) % 60);
    this.campos.segundos.textContent = dos(s % 60);

    if (restante === 0) {
      clearInterval(this.intervalo);
      const final = this.parentElement.querySelector('.preventa__final');
      if (final) final.hidden = false;
    }
  }
}

customElements.define('preventa-cuenta', PreventaCuenta);

document.querySelectorAll('.preventa').forEach((preventa) => {
  const dialogo = preventa.querySelector('.preventa__dialogo');

  preventa.querySelector('[data-abrir-acceso]').addEventListener('click', () => {
    dialogo.showModal();
    dialogo.querySelector('input[type="password"]').focus();
  });
  dialogo.querySelector('[data-cerrar-acceso]').addEventListener('click', () => dialogo.close());
  // Clic fuera de la tarjeta: el backdrop cuenta como el propio <dialog>
  dialogo.addEventListener('click', (event) => {
    if (event.target === dialogo) dialogo.close();
  });
  // Contraseña equivocada: Shopify recarga la página con el error; se reabre
  if (dialogo.querySelector('[aria-invalid="true"]')) dialogo.showModal();

  // En móvil la invitación va encima del campo y el campo lleva otro texto
  const correo = preventa.querySelector('#PreventaCorreo-email');
  if (correo) {
    const escritorio = correo.placeholder;
    const movil = window.matchMedia('(max-width: 749px), (orientation: portrait)');
    const ajustar = () => {
      correo.placeholder = movil.matches ? correo.dataset.placeholderMovil : escritorio;
    };
    ajustar();
    movil.addEventListener('change', ajustar);
  }
});
